import { Route, Switch } from 'react-router-dom';

import PreviewPage from 'components/PreviewPage';
import NotebookPage from 'components/NotebookPage';

export default function Routes() {
	return (
		<Switch>
			<Route exact path='/crea' component={PreviewPage}></Route>
			<Route exact path='/quaderno-faboola' component={NotebookPage}></Route>
		</Switch>
	);
}
